
(function () {
    window.WatchlistApp = window.WatchlistApp || {};

    const State = {
        currentView: 'chart',
        currentSortOption: 'alphabetical',
        currentSortOrder: 'asc',
        totalStocks: 0,
        currentWatchlistData: null,
        currentUserId: null,
        currentWatchlistId: null,
        allWatchlists: [],
        missingTickersCount: 0,

        pendingAdditions: [],
        pendingRemovals: [],

        addPendingAddition: function (ticker, data, watchlistId) {
            this.pendingAdditions = this.pendingAdditions.filter(p => p.ticker !== ticker || p.watchlistId !== watchlistId);
            this.pendingAdditions.push({
                ticker: ticker,
                watchlistId: watchlistId,
                timestamp: Date.now(),
                data: data || {}
            });
            this.pendingRemovals = this.pendingRemovals.filter(p => p.ticker !== ticker || p.watchlistId !== watchlistId);
        },

        addPendingRemoval: function (ticker, watchlistId) {
            this.pendingRemovals = this.pendingRemovals.filter(p => p.ticker !== ticker || p.watchlistId !== watchlistId);
            this.pendingRemovals.push({
                ticker: ticker,
                watchlistId: watchlistId,
                timestamp: Date.now()
            });
            this.pendingAdditions = this.pendingAdditions.filter(p => p.ticker !== ticker || p.watchlistId !== watchlistId);
        },

        cleanPending: function (currentStockData) {
            const now = Date.now();
            const EXPIRY = 300000;

            this.pendingRemovals = this.pendingRemovals.filter(p => (now - p.timestamp) < EXPIRY);
        },

        getCurrentWatchlistStockCount: function () {
            return this.totalStocks;
        },

        setCurrentWatchlistStockCount: function (count) {
            const n = Number(count);
            this.totalStocks = (Number.isFinite(n) && n >= 0) ? Math.floor(n) : 0;
        },

        adjustCurrentWatchlistStockCount: function (delta) {
            this.setCurrentWatchlistStockCount(this.totalStocks + Number(delta || 0));
        },

        resetForNewWatchlist: function () {
            this.currentWatchlistData = null;
            this.totalStocks = 0;
            this.missingTickersCount = 0;
            this.pendingAdditions = [];
            this.pendingRemovals = [];
        },

        fullReset: function () {
            this.currentView = 'chart';
            this.currentSortOption = 'alphabetical';
            this.currentSortOrder = 'asc';
            this.totalStocks = 0;
            this.currentWatchlistData = null;
            this.currentUserId = null;
            this.currentWatchlistId = null;
            this.missingTickersCount = 0;
            this.pendingAdditions = [];
            this.pendingRemovals = [];
        }
    };

    window.WatchlistApp.State = State;
})();
